import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import swal from "sweetalert";
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Calendardatepicker from "./Calendardatepicker.js";
import Calendardatepickerpopup from "./Calendardatepickerpopup.js";
import Calendartimepicker from "./Calendartimepicker.js";
import Reminderselect from "./Reminderselect.js";
import UserSpecificCalendar from "./UserSpecificCalendar";
import UserSpecificList from "./UserSpecificList";

import Grid from "@material-ui/core/Grid";
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import OffileDb from '../../config/pouchDB';
import Services from "../../api/api";
import Loader from "../loaders/loader";

import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Calendarsettings from "./calendarsettings.js";
import Calendarsetreminder from "./calendersetreminder.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

function FullWidthTabs(props) {
  const { t } = props;
  const { templateID } = props;
  let bgStyles = templateID == 2 ? { background: props.componentbgcolor } : {};
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [firstBleeding, setFirstBleeding] = React.useState(new Date());
  const [reminderTime, setreminderTime] = React.useState(new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
  const [reset, setreset] = React.useState(false);
  const [reminderType, setreminderType] = React.useState(1);
  const [userCalenderRemainderInfo, setUserCalenderRemainderInfo] = React.useState(null);
  const [isLoading, setisLoading] = React.useState(true);
  const [editRemainderObj, seteditRemainderObj] = React.useState(null);




  useEffect(() => {
    let mounted = true;
    var param = {
      communityId: props.communityuid,
      languageId: props.langId,
    };
    //param = { "communityId": "87853cf35173ae650eca36b1f0375d6c", "userId": 2423 }
    console.log(param)
    try {
      Services.getCalenderRemaindersForUser(param).then((res) => {
        try{
          console.log(res)
          if (res.status && res.status == 200) {
            console.log(mounted)
            if (mounted) {
              setUserCalenderRemainderInfo(res.data.data);
              setisLoading(false);
            }
          } else {
            console.log('err')
            setisLoading(false);
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    } catch (err) {
      console.log(err)
    }

    return () => mounted = false;
  }, [])

  const handleChange = (event, newValue) => {
    setreset(false)
    seteditRemainderObj(null)
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function goToUserSpecoficTab(index) {
    setValue(index);
  }

  return (
    <>
      {
        templateID == 1 && (
          <div className="backgroundivholder">
            <div className="bgdiv1">
              <div class="welcometopcurve">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                  <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                </svg>
              </div>
            </div>
            <div className="bgdiv2"></div>
          </div>
        )
      }

      <div className={classes.root}>
          <AppBar className="tabheader" position="static" color="default" style={bgStyles}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label={t("Schedule Pill")} {...a11yProps(0)} />
              <Tab label={t("Reminder List")} {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className="calendartabpanel">
              <div className="calendartabmainholder">
                <div className="calendarholder">
                  {isLoading ? (<Loader isLoading={isLoading} />) : (
                    <>
                      {
                        userCalenderRemainderInfo != null ?
                          (<Calendardatepicker userCalenderRemainderInfo={userCalenderRemainderInfo} reminderTime={reminderTime} firstBleeding={firstBleeding} reset={reset}></Calendardatepicker>)
                          : (<div className="padding10 nodatafound">{t("Data not found")}</div>)
                      }
                      <div className='pillstatusholder'>
                        <div>
                          <Grid container spacing={12} className="gridcontainer">
                            <Grid item xs={12} className="d-flex aligin-items-center">
                              <div className={templateID == 1 ? "getknwtitle text-left" : "color-green"}>{t('Would you like to set up your own reminder?')}</div>
                            </Grid>
                            <Grid item xs={12} className="text-left mt-20px" onClick={() => { goToUserSpecoficTab(1) }}>
                              <Button
                                type="submit"
                                variant="contained"
                                style={bgStyles}
                                color="primary"
                                disableElevation
                                className={templateID == 1 ? "login_btn" : "reportsubmitbtn"}
                              >
                                {t('Go')}
                              </Button>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </>
                  )
                  }
                </div>
              </div>
            </TabPanel>
            {/* <TabPanel value={value} index={1} dir={theme.direction} className="calendartabpanel">
          <div className="calendartabmainholder">
            <Grid container spacing={3} className="gridcontainer">
              <Grid item xs={12} className="">
                <Card className="border-grey mt-10px">
                  <CardContent className="zero">
                    <p className="zero settingcardheader" style={{ color: props.componentbgcolor }}>{t("Reset Pill Tracker")}</p>
                    <p className="zero p-10px">{t("Do you want to reset pill tracker with this as your first date?")}</p>
                    <p className="zero p-10px">
                      <Calendardatepickerpopup onDateChange={(date) => { onDateChange(date) }}></Calendardatepickerpopup>
                    </p>
                    <p className="zero p-10px pb-15px">
                      <Button variant="contained" style={{ color: "#fff", background: props.componentbgcolor }} onClick={() => { resetCalender() }}>{t("Reset")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} className="">
                <Card className="border-grey">
                  <CardContent className="zero">
                    <p className="zero settingcardheader" style={{ color: props.componentbgcolor }}>{t("Reset Reminder Time")}</p>
                    <p className="zero p-10px">{t("This is the time we will remind you for taking your pills!")}</p>
                    <p className="zero p-10px">
                      <Calendartimepicker onTimeChange={(time) => { onTimeChange(time) }}></Calendartimepicker>
                    </p>
                    <p className="zero p-10px pb-15px">
                      <Button variant="contained" style={{ color: "#fff", background: props.componentbgcolor }} onClick={() => { setTime() }}>{t("Set Time")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} className="">
                <Card className="border-grey mb-20px">
                  <CardContent className="zero">
                    <p className="zero settingcardheader" style={{ color: props.componentbgcolor }}>{t("Reset Reminder Type")}</p>
                    <p className="zero p-10px">{t("You'll be reminded via this mode of notification!")}</p>
                    <p className="zero p-10px">
                      <Reminderselect onTypeChange={(type) => { onTypeChange(type) }}></Reminderselect>
                    </p>
                    <p className="zero p-10px pb-15px">
                      <Button variant="contained" style={{ color: "#fff", background: props.componentbgcolor }} onClick={() => { changeMode() }}>{t("Change Mode")}</Button>
                    </p>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
          </div>
        </TabPanel> */}

            {/* <TabPanel value={value} index={2} dir={theme.direction} className="calendartabpanel remindertabpanel">
          <div className="calendartabmainholder">
            <UserSpecificCalendar editRemainderObj={editRemainderObj} onSaveChange={() => { goToUserSpecoficTab(3) }} ></UserSpecificCalendar>
          </div>
        </TabPanel> */}


            <TabPanel value={value} index={1} dir={theme.direction} className="calendartabpanel">
              <div className="usercalendartabmainholder">
                <Grid container spacing={3} className="gridcontainer">
                  {/* <Calendarsetreminder></Calendarsetreminder> */}
                  <UserSpecificList></UserSpecificList>
                </Grid>
              </div>
            </TabPanel>
          </SwipeableViews>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: state.storeState.communityId,
    langId: state.storeState.langId,
    componentbgcolor: state.storeState.componentbgcolor
  };
}

export default connect(mapStateToProps)(withTranslation()(FullWidthTabs));